import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const appURL = URL + 'gis_gmp/api/'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    downloadReportCharge ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportCharge'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-charge/'
        const data = new FormData()
        if (payload.date_begin) {
          data.append('date_begin', payload.date_begin)
        }
        if (payload.date_end) {
          data.append('date_end', payload.date_end)
        }
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', data: data, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Реестр начислений.xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadReportConsolidatedCharges ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportConsolidatedCharges'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-consolidated-charges/'
        const data = new FormData()
        if (payload.date_begin) {
          data.append('date_begin', payload.date_begin + '-01')
        }
        if (payload.date_end) {
          data.append('date_end', payload.date_end + '-01')
        }
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', data: data, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Сводный отчет по начислениям.xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadReportCoincidenceChargePayment ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportCoincidenceChargePayment'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-coincidence-charge-payment/'
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Реестр совпавших несквитированных начислений с несквитированными уплатами.xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    downloadReportWorkKDNMonth ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'downloadReportWorkKDNMonth'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = appURL + 'report-work-kdn-month/'
        const data = new FormData()
        data.append('month', payload.month + '-01')
        const download = require('js-file-download')
        session({ url: _url, method: 'POST', responseType: 'blob', data: data, headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            download(response.data,
              'Информация о количестве направленных начислений в ГИС ГМП за период.xlsx',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
  }
}
